import { CheckBox, FormField } from "grommet";
import React from "react";

const CheckboxFormField = ({
  label,
  id,
  setValues,
  handleBlur,
  touched,
  values,
  errors,
}: {
  label: string;
  id: string;
  setValues: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  values: any;
  errors: any;
}) => (
  <FormField
    name={id}
    error={touched[id] && errors[id]}
  >
    <CheckBox
      name={id}
      onBlur={handleBlur}
      checked={values[id]}
      onChange={(event) => {
        setValues({ ...values, [id]: event.target.checked })
      }
      }
      label={label}
    />
  </FormField>
)

export default CheckboxFormField;
